<template>
    <router-link class="list-item-root" :to="to">
        <div class="d-flex align-items-center px-3 py-2 clickable" :class="classes">
            <div v-if="!!image" row class="image-wrapper" align-center>
                <img class="image-default d-center image" :src="image" alt="title" />
            </div>

            <div class="content d-flex flex-column justify-content-center">
                <h6 class="subtitle mb-1" style="font-size: 16px;">
                    {{ header }}
                </h6>

                <div v-if="subheader" class="d-flex align-items-center mute mb-1">
                    <BaseIcon size="xs" :name="icon" />

                    <h6 class="caption m-0" style="font-size: 14px;">
                        {{ subheader }}
                    </h6>
                </div>

                <div v-if="subtitle" class="d-flex align-items-center mute">
                    <h6 v-if="subtitle" class="caption2 mb-0">
                        {{ subtitle }}
                    </h6>
                </div>
            </div>
        </div>
        <Divider />
    </router-link>
</template>

<script>
export default {
    name: 'ListItem',
    props: {
        to: {
            type: [Object, String],
            required: true,
        },
        image: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            required: true,
        },
        header: {
            type: String,
            required: true,
        },
        subheader: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        classes: {
            type: String,
            default: '',
        }, // Styling
    },
};
</script>

<style scoped>
.list-item-root {
    text-decoration: none;
}
.clickable:hover {
    background-color: whitesmoke;
}
.content {
    min-height: 80px;
}
.image-wrapper {
    margin: 0 10px 0 0;
    width: 65px;
    max-width: 65px;
    min-width: 65px;
}
.image {
    width: 50px;
    overflow: hidden;
}

.caption2 {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6) !important;
}
</style>
